<template>
  <div>
    <head-item></head-item>
    <el-row>
      <el-col :span="4">
          <nav-item :roleCode="roleCode"></nav-item>
      </el-col>
      <el-col :span="20" class="content">
        <!-- <keep-alive >
            <router-view class="app-router-view"  v-if="$route.meta.keepAlive"></router-view>
        </keep-alive> -->
        <transition name="move-fade-right-to-left">
          <router-view class="app-router-view"></router-view>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headItem from '../components/headItem'
import navItem from '../components/navItem.vue'
export default {
  name: 'index',
  data () {
    return {
      roleCode: ''
    }
  },
  components: {
    headItem,
    navItem
  },
  mounted () {
    this.roleCode = sessionStorage.getItem('roleCode')
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
    min-height: 36px;
  }
.el-row {
  height: 100%;
}
.el-col-4 {
  min-height: 1280px;
}
.content {
  padding: 30px;
}
</style>